<ds-input
  class="w-100"
  [formControl]="formControl"
  [label]="props.label"
  [placeholder]="props.placeholder || ''"
  [type]="inputType"
  [helper]="helper"
  [error]="error"
  [inputId]="id"
  [autocomplete]="autocomplete"
  [attr.data-id]="field.key"
/>
